window.onload = function () {
  const lazyLoadElements = document.querySelectorAll('img[data-src], video[data-src], source[data-src]');
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const element = entry.target;
        element.src = element.dataset.src;
        element.removeAttribute('data-src');
        observer.unobserve(element);
      }
    });
  }, {
    rootMargin: '50px'
  });

  lazyLoadElements.forEach(el => observer.observe(el));
};
